import { MdOutlineLocalTaxi } from "react-icons/md";
import { VscGitPullRequestNewChanges } from "react-icons/vsc";
import { TbCurrentLocation } from "react-icons/tb";

export const operatorLinks = [
    {
        title: "ادارة السائقين",
        icon: <MdOutlineLocalTaxi />,
        path: "/drivers",
    },
    // {
    //     title: "ادارة السائقين النشطين",
    //     icon: <TbCurrentLocation />,
    //     path: "/active-drivers",
    // },
    {
        title: "ادارة الطلبات  ",
        icon: <VscGitPullRequestNewChanges />,
        path: "/orders",
    },
];
